import getBatchMetricsTransportSettings from 'src/internal/metrics/transport/batchMetricsTransportSettings';
import createBatchingTransport from 'src/internal/transport/createBatchingTransport';

import type {
  MetricEvent,
  MetricsTransport,
  MetricsTransportConfig,
} from 'src/internal/metrics/types';

export default function createBatchingMetricsTransport(
  config: MetricsTransportConfig,
): MetricsTransport {
  const settings = getBatchMetricsTransportSettings(
    config.useAelMetricsEndpoint,
  );

  return createBatchingTransport<MetricEvent>({
    ...settings,
    fetch: config.fetch,
    service: config.service,
    flushSignal: config.flushSignal,
  });
}
